import { jsonify } from "@/zapi-admin/shared/utils/json";
import MonacoEditor from "@monaco-editor/react";

function getImprovedJsonObj(obj: string | object) {
  try {
    if (typeof obj === "string") return jsonify(JSON.parse(obj));
    return jsonify(obj);
  } catch (_) {
    if (typeof obj === "string") return obj;
    return "ERROR";
  }
}
export function JsonViewer({ json }: { json: string | object }) {
  const value = JSON.stringify(getImprovedJsonObj(json), null, 2);

  return (
    <div className="h-full">
      <MonacoEditor
        width="100%"
        height="100%"
        language="json"
        theme="light"
        value={value}
        options={{
          readOnly: true,
          minimap: { enabled: false },
          wordWrapColumn: 120,
          scrollBeyondLastLine: false,
          renderWhitespace: "all",
          automaticLayout: true,
          stickyScroll: { enabled: false },
          wordWrap: "wordWrapColumn"
        }}
      />
    </div>
  );
}
